import React from 'react';

const UserDashboard = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>User Dashboard</h1>
      {/* Add your desired content and functionality for the user dashboard */}
    </div>
  );
};

export default UserDashboard;